module.exports = __webpack_public_path__ + "static/media/rodo.902a02b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/threats/4/rodo.svg
// module id = 371
// module chunks = 0